import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Notification = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='m3.968 16.348-.74-.12zm16.252 0 .74-.12zm-1.17-7.259-.741.12zm-13.912 0 .74.12zM1.755 7.461a.75.75 0 0 0 1.443.411zm3.97-3.753A.75.75 0 0 0 4.692 2.62zm13.77-1.088a.75.75 0 0 0-1.032 1.088zm1.495 5.252a.75.75 0 0 0 1.442-.411zM18.309 9.21l1.17 7.258 1.481-.239-1.17-7.258zm-.064 8.707H5.942v1.5h12.303zm-13.537-1.45 1.17-7.258-1.48-.239-1.17 7.258zm1.234 1.449a1.25 1.25 0 0 1-1.234-1.449l-1.48-.239a2.75 2.75 0 0 0 2.714 3.188zm13.537-1.449a1.25 1.25 0 0 1-1.234 1.449v1.5a2.75 2.75 0 0 0 2.715-3.188zM12.094 3.916a6.295 6.295 0 0 1 6.215 5.293l1.48-.239a7.795 7.795 0 0 0-7.695-6.554zm0-1.5A7.795 7.795 0 0 0 4.398 8.97l1.48.239a6.295 6.295 0 0 1 6.216-5.293zm3.299 15.983c-.585 1.533-1.88 2.517-3.3 2.517v1.5c2.159 0 3.94-1.484 4.702-3.483zm-3.3 2.517c-1.42 0-2.714-.984-3.298-2.517l-1.402.534c.762 1.999 2.543 3.483 4.7 3.483zM3.199 7.872a9.25 9.25 0 0 1 2.527-4.164L4.692 2.62a10.75 10.75 0 0 0-2.937 4.84zm15.265-4.164a9.25 9.25 0 0 1 2.527 4.164l1.442-.411a10.75 10.75 0 0 0-2.936-4.84z'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.094 2.416A7.795 7.795 0 0 0 4.398 8.97l-1.17 7.258a2.75 2.75 0 0 0 2.714 3.188h1.66c.849 1.75 2.511 3 4.492 3s3.643-1.25 4.492-3h1.66a2.75 2.75 0 0 0 2.714-3.188L19.79 8.97a7.795 7.795 0 0 0-7.696-6.554m2.753 17H9.34c.678.937 1.68 1.5 2.754 1.5s2.076-.563 2.753-1.5'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.752 2.648a.75.75 0 0 1-.027 1.06 9.25 9.25 0 0 0-2.527 4.164.75.75 0 0 1-1.443-.411 10.75 10.75 0 0 1 2.937-4.84.75.75 0 0 1 1.06.027m12.683 0a.75.75 0 0 1 1.06-.028 10.75 10.75 0 0 1 2.937 4.84.75.75 0 0 1-1.442.412 9.25 9.25 0 0 0-2.527-4.164.75.75 0 0 1-.028-1.06'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
